import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import UsersService from "../../services/UserService";
import NotFound from "../../components/not-found";
import Breadcrumbs from "../../components/breadcrumbs";
import ProfileForm from "./ui/ProfileForm";
export default function ProfilePage() {
  const auth = useAuth();
  const api = new UsersService();
  useEffect(() => {}, []);
  if (!auth.user && auth.ready) return <NotFound message="User not found." />;
  console.log(auth.user);
  const fetchProfile= async ()=>{
    const user = await api.getMyProfile();
    auth.login(user.data);
  }
  return (
    <main className="max-w-3xl ">
      <Breadcrumbs breadcrumbs={[{ label: "Profile", href: "#" }]} />
      {/* {!loading && message ? (
            <ContactUsForm message={message} />
          ) : (
            <ContactUsFormSkeleton />
          )} */}
      {auth.user ? <ProfileForm user={auth.user} reloadProfile={fetchProfile}></ProfileForm> : null}
    </main>
  );
}
